export default function getCurrentMonday() {
  const crr = new Date();
  const date = new Date();
  let dayOfWeek = crr.getDay();
  if (dayOfWeek == 0) {
    dayOfWeek = 7;
  }

  date.setDate(date.getDate() - (dayOfWeek - 1));
  date.setHours(0, 0, 0, 0);

  return date;
}
